import { Injectable } from '@angular/core';
import * as CoreGoogleAnalyticActions from '@fantaz/core/analytic/actions';
import { getCurrentUser } from '@fantaz/shared/auth';
import { GAEventKeys, User } from '@fantaz/shared/data-access/models';
import { Store } from '@ngrx/store';
import { NgxZendeskWebwidgetService } from 'ngx-zendesk-webwidget/service';
import { Observable, filter, from, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FzZendeskService {
  initZendesk$: Observable<any>;
  private filledUserData: boolean;
  private user: User;
  private openRetryTimer = 0;
  private ref: any;

  constructor(
    private ngxZendeskWebwidgetService: NgxZendeskWebwidgetService,
    private store: Store,
  ) {}

  init() {
    try {
      this.initZendesk$ = from(this.ngxZendeskWebwidgetService.initZendesk());
      this.initZendesk$.pipe(take(1)).subscribe(() => {
        if (!this.filledUserData && this.user) {
          const { username, email } = this.user;
          this.fillUserData(username, email);
        }
      });
    } catch (error) {
      console.error(error);
    }

    this.store
      .select(getCurrentUser)
      .pipe(
        filter((user) => user != null),
        take(1),
      )
      .subscribe((currentUser) => {
        if (currentUser?.user) {
          this.user = currentUser.user;
          const { username, email } = currentUser.user;
          this.fillUserData(username, email);
        }
      });
  }

  fillUserData(username: string | undefined, email: string) {
    if (typeof this.ngxZendeskWebwidgetService.zE === 'function') {
      try {
        this.ngxZendeskWebwidgetService.zE('webWidget', 'prefill', {
          name: {
            value: username,
            readOnly: true,
          },
          email: {
            value: email,
            readOnly: true,
          },
        });
        this.filledUserData = true;
      } catch (error) {
        console.error(error);
      }
    }
  }

  openZendesk() {
    this.openRetryTimer++;
    const currentFrame: any = document.getElementById('launcher');
    const widgetOpen = document.getElementById('webWidget');
    if (
      currentFrame &&
      currentFrame?.contentWindow &&
      currentFrame?.contentWindow?.document &&
      !widgetOpen
    ) {
      this.openRetryTimer = 0;
      const currentDocument = currentFrame?.contentWindow?.document;
      const elem = currentDocument.querySelector('button');
      if (elem) {
        elem.click();
        this.store.dispatch(
          CoreGoogleAnalyticActions.trackEvent({
            event: { event: GAEventKeys.USER_REQUEST_ZENDESK },
          }),
        );
      }
    } else {
      // Retry three times to await for the ZenDesk will ready
      if (this.openRetryTimer <= 10) {
        this.ref = setTimeout(() => {
          clearTimeout(this.ref);
          this.openZendesk();
        }, 2000);
      }
    }
  }
}
